import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import Solutions from './Solutions';
// import Resources from './Resources';

import {
  answerQuestion,
  getSurveys,
  reset,
} from '../../redux/actions/SurveyAction';

import './survey.scss';
import { Loader } from '../../components';
import SurveyCard from './SurveyCard';
import { getMyResources } from '../../redux/actions/Resources';
import { getSolutionsLatest } from '../../redux/actions/Solutions';
import CompleteSurvey from './CompleteSurvey';

// Import the video file (if it's a local file)
// import sampleVideo1 from '../../assets/sample-video1.mp4';
// import sampleVideo2 from '../../assets/sample-video2.mp4';

const Survey = ({
  getSurveys,
  surveys,
  getSurveysRequest: { loading },
  answerQuestion,
  saveAnswer,
  getMyResources,
  getSolutionsLatest,
  reset,
  solutions,
}) => {
    console.log('solutions', solutions);
  const [surveyCompleted, setComplete] = useState(false);
  useEffect(() => {
    getSurveys();
    getSolutionsLatest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const completeSurvey = () => {
    setComplete(true);
    // getMyResources();
    getSolutionsLatest();
  };

  // const ChatbotFrame = () => {
  //   return (
  //     <iframe
  //       src="https://app.customgpt.ai/projects/66376/ask-me-anything?embed=1&shareable_slug=9db9b009dc35ebdf9a96450a033307e0"
  //       width="100%"
  //       height="400"
  //       style={{ border: 'none', borderRadius: '8px' }}
  //       loading="lazy"
  //       title="Chatbot"
  //     />
  //   );
  // };
  

  if (loading) return <Loader />;

  const questions = (surveys?.questions && surveys.questions) || [];
  const index = questions.findIndex((q) => !q.answer);
  const showSurvey = questions.length && index !== -1;
  return (
    <div className="dashboard-wrapper">
      <div className="content-body">
        <div className="video-container">
          <div className="video-wrapper">
            <iframe width="560" height="315" src="Https://peakmindmedia.sfo3.digitaloceanspaces.com/Exercise%20&%20Videos/Home%20Screen%20Explainer%20Video.mp4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          <div className="video-wrapper">
            <iframe width="560" height="315" src="https://peakmindmedia.sfo3.digitaloceanspaces.com/Exercise%20&%20Videos/Beach%20Meditation.mp4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          {/* <div className="video-wrapper">
            <ChatbotFrame />
          </div> */}
        </div>
        <div className="main-content">
          {showSurvey ? (
            <SurveyCard
              surveyCompleted={surveyCompleted}
              surveys={surveys}
              saveAnswer={saveAnswer}
              answerQuestion={answerQuestion}
              setComplete={completeSurvey}
              reset={reset}
            />
          ) : (
            <div className="survey-wrapper">
              <CompleteSurvey
                hide
                headingText="Take a look around"
                infoText="You don't have any surveys to complete at the moment"
              />
            </div>
          )}
          <div className="custom-main-card">
            {/*<Reports surveyCompleted={solutions.length} />*/}
            <Solutions surveyCompleted={solutions.length} />
            {/*<Resources surveyCompleted={surveyCompleted} />*/}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  surveys: state.survey.surveys,
  getSurveysRequest: state.survey.getSurvey,
  saveAnswer: state.survey.saveAnswer,
  solutions: state.solutions.solutionsLatest,
});

const mapDispatchToProps = (dispatch) => ({
  getSurveys: () => {
    dispatch(getSurveys());
  },
  answerQuestion: (payload) => {
    dispatch(answerQuestion(payload));
  },
  getMyResources: () => {
    dispatch(getMyResources());
  },
  getSolutionsLatest: () => {
    dispatch(getSolutionsLatest());
  },
  reset: (block) => {
    dispatch(reset(block));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Survey);